import { cn } from '../lib/cn';

/**
 * El aspecto compartido de todo lo que se escribe.
 *
 * Vive aparte de `Field` porque no es un componente: lo usan el propio `Field`,
 * los controles de `form/Inputs`, y la docena de `select` y `textarea` sueltos
 * que las pantallas siguen necesitando. Tenerlo en un fichero de componentes
 * obligaba a importar un módulo con JSX solo para copiar unas clases.
 */
export const fieldStyles = cn(
  'w-full rounded-sm border bg-raised px-3 py-2.5 text-sm text-ink outline-none',
  'placeholder:text-ink-faint',
  'transition-[border-color,box-shadow] duration-fast',
  'focus:border-primary focus:shadow-[0_0_0_3px] focus:shadow-primary/15',
  'disabled:cursor-not-allowed disabled:opacity-55',
);

/**
 * El aspecto de una entrada de menú, aparte del componente que la pinta.
 *
 * Lo necesita quien tiene que renderizar un `<Link>` en lugar del `<button>` de
 * `MenuItem` —el selector de empresa, sin ir más lejos—, porque una entrada que
 * navega tiene que ser un enlace de verdad: se abre en otra pestaña, se copia
 * su dirección, y el lector de pantalla la anuncia como lo que es.
 */
export function menuItemStyles(active = false, className?: string): string {
  return cn(
    'flex w-full items-center gap-2.5 rounded-sm px-2.5 py-2 text-left text-sm transition-colors duration-fast',
    active ? 'bg-primary-pale font-semibold text-primary' : 'text-ink-soft hover:bg-muted hover:text-ink',
    className,
  );
}
